import api from "@/services/api.service";
import { email, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'add',
  components: {},
  props: [],
  data () {
    return {
        caption:"Contact Add",
        campaigns:[],
        formField:{first_name:'',last_name:'',personal_email:'',personal_phone:'',residential_address:'',business_email:'',business_phone:''},
        submitStatus: null,
        permission_add: false,
        superAdmin: false
    }
  },
  computed: {

  },
  mounted () {

  },
    validations: {
        formField: {
            first_name: {},
            last_name: {},            
            personal_email:{ email },
            personal_phone:{ maxLength: maxLength(14) },
            business_phone:{ maxLength: maxLength(14) },
            business_email:{ email },
            residential_address:{},middle_name:{},residential_city:{},residential_state:{},residential_zipcode:{},
            business_address:{},business_city:{},business_state:{},business_zipcode:{},job_title:{},year_of_birth:{},dob:{},
            retirement_year:{},retired:{},income:{},tcp_saving:{},qualified_saving:{},non_qualified_saving:{},life_insurance:{},facebook:{},linked_in:{},
            twitter:{},other:{},hourly:{},date_of_hire:{},pay_location:{},employer:{}
        }
    },
  created(){ this.getUserPermissions(); },
  methods: {
      acceptNumber(e) {    
        if(e === 'business_phone'){
    	var  x1= this.formField.business_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,5})/);
        this.formField.business_phone = !x1[2] ? x1[1] : '(' + x1[1] + ') ' + x1[2] + (x1[3] ? '-' + x1[3] : '');}
        
        if(e === 'personal_phone'){
    	var x = this.formField.personal_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,5})/);
        this.formField.personal_phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');        }
      },
      makeToast(message = '',title='Alert',variant='warning') 
      {
          this.toastCount++
          this.$root.$bvToast.toast(message, {
              title:title,
              variant:variant,
              autoHideDelay: 3000
          })
      },
      async getUserPermissions(){
        let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_contact") == true){
                this.permission_add = permissions.includes("add_contact");
            }else if(response.data[0].role == 'super_admin'){
                this.superAdmin = true;
            }else if(permissions.includes("list_contact") == true || permissions.includes("add_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'List Contacts'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }      
      },
      async save()
      {
          this.$v.$touch();
          if (this.$v.$invalid) {
              this.submitStatus = 'ERROR'
          } else {
              let response = await api.post('contact/add-contact', this.formField);
              if (!response)
                  this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status=='success') {
                    this.makeToast(response.message,'Success','success');
                    this.$router.push({name:"List Contacts"})
                } else {
                    for (var error in response.errors) {
                        this.makeToast(response.errors[error],'Alert','danger');
                    }
                }
          }
      }
  }
}


